import React from 'react';
import { Whisper, Popover } from 'rsuite';
import ScheduleItem from './ScheduleItem';

const CalendarCell = ({ 
    date, 
    schedules, 
    canManage, 
    getColorForType, 
    onDateClick,
    onDateDoubleClick, 
    onDragOver, 
    onDrop, 
    onDragStart, 
    onRemoveSchedule,
    cellItemCount = 4,
    isSelectionMode = false,
    isSelected = false
}) => {
    const list = schedules || [];
    const displayList = list.slice(0, cellItemCount);

    return (
        <div
            className={`calendar-cell-container ${isSelected ? 'selected' : ''}`}
            onDragOver={onDragOver}
            onDrop={(e) => onDrop(e, date)}
            onClick={() => onDateClick(date)}
            onDoubleClick={(e) => {
                // 在選取模式下，阻止雙擊事件觸發
                if (isSelectionMode) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                onDateDoubleClick(date);
            }}
            style={{ 
                height: '100%',
                minHeight: '50px',
                position: 'relative',
                cursor: canManage ? 'pointer' : 'default',
                backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                border: isSelected ? '2px solid #2196f3' : '1px solid transparent',
                borderRadius: isSelected ? '4px' : '0px'
            }}
        >
            {list.length > 0 && (
                <ul className="calendar-schedule-list">
                    {displayList.map((item, index) => (
                        <li key={index}>
                            <ScheduleItem
                                item={item}
                                date={date}
                                canManage={canManage}
                                getColorForType={getColorForType}
                                onDragStart={onDragStart}
                                onRemove={onRemoveSchedule}
                                isPopover={false}
                            />
                        </li>
                    ))}
                    {list.length > cellItemCount && (
                        <li key="more">
                            <Whisper
                                placement="top"
                                trigger="click"
                                speaker={
                                    <Popover style={{ maxWidth: '300px' }}>
                                        {list.map((item, index) => (
                                            <ScheduleItem
                                                key={index}
                                                item={item}
                                                date={date}
                                                canManage={canManage}
                                                getColorForType={getColorForType}
                                                onDragStart={onDragStart}
                                                onRemove={onRemoveSchedule}
                                                isPopover={true}
                                            />
                                        ))}
                                    </Popover>
                                }
                            >
                                <a>{list.length - cellItemCount} 更多</a>
                            </Whisper>
                        </li>
                    )}
                </ul>
            )}
        </div>
    );
};

export default CalendarCell;
